export const getInternalNavigationHref = (href: string, origin: string): string | undefined => {
  try {
    const url = new URL(href, origin);

    if (url.origin !== origin) {
      return undefined;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return undefined;
  }
};
